import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';

const changeAddressSale = async ({ flatId, SaleAddressLifeCycleId }) => {
  const res = await request.put(
    `/FlatsGrid/change_sale_address_life_cycle/${flatId}`,
    { SaleAddressLifeCycleId },
    'Не удалось изменить стадию продажи',
  )
  return res;
}

const useChangeAddressSale = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(changeAddressSale, {
    onSuccess: (data, {flatsGridQueryKey}) => queryClient.invalidateQueries(flatsGridQueryKey),
  })

  return {
    chengeAsync: mutation.mutateAsync,
    loading: mutation.isLoading,
  }
}

export { useChangeAddressSale }